import { User } from '@hakimo-ui/hakimo/types';

export function isUserComplete(user: User): boolean {
  return user.name ? user.name?.length > 0 : false;
}

export const USER_NOT_SETUP_MESSAGE = 'Invalid user';

export const DEFAULT_IDLE_TIMEOUT_MINUTES = 60;
